import AutocompleteInput from 'app/components/AutocompleteInput';
import FilterStack from './FilterStack';

import useFilter, {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

// filter class (doesn't change)
const FILTER_CLASS = TEXT;

// filter type won't be changed for the autocomplete filter
const FILTER_TYPE = EQUALS;

const AutocompleteFilterStack = props => {
  return (
    <FilterStack
      {...props}
      FilterComponent={AutocompleteFilter}
      filterClass={FILTER_CLASS}
      defaultFilterType={FILTER_TYPE}
    />
  );
}

const AutocompleteFilter = props => {
  const valueFormatter = (event, option) => option.value.toString();

  const {
    value,
    onChange
  } = useFilter({
    ...props,
    filterClass: FILTER_CLASS,
    filterType: FILTER_TYPE,
    valueFormatter
  });

  const { inputOptions, getInputOptions } = props.filterParams.colDef;

  let variant = 'filled';
  let size = 'small';
  let inputSx = {
    padding: '0 0.5rem !important' // not working, added to App.scss
  }
  
  return (
    <AutocompleteInput
      initialValue={value}
      inputOptions={inputOptions}
      getInputOptions={getInputOptions}
      variant={variant}
      size={size}
      inputSx={inputSx}
      onChange={onChange}
      sx={props.sx}
    />
  );
}

export default AutocompleteFilterStack;
